export default __webpack_public_path__ + "static/PM_DLabs-m-259c161a7ea3be22e7bb1402d59b68b5.jpg";